import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { Account } from '../../types'
import type { RootState } from '../index'

const AVG_DAILY_COST_KOPECKS = 1700

interface AccountState {
  account: Account | null
}

const initialState: AccountState = {
  account: null,
}

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setAccount(state, action: PayloadAction<Account | null>) {
      state.account = action.payload
    },
    clearAccount(state) {
      state.account = null
    },
  },
})

// Selectors
export const selectAccount = (state: RootState) => state.account.account
export const selectBalanceRubles = (state: RootState) =>
  (state.account.account?.balance || 0) / 100
export const selectIsBlocked = (state: RootState) =>
  state.account.account?.status === 'blocked'
export const selectDaysRemaining = (state: RootState) => {
  const account = state.account.account
  if (!account) return 0
  return Math.max(0, Math.floor((account.balance || 0) / AVG_DAILY_COST_KOPECKS))
}

export const { setAccount, clearAccount } = accountSlice.actions
export default accountSlice.reducer
